module.exports = __webpack_public_path__ + "static/media/attack-1.05bd46c1.png";